export const companyGovernmentAllocationsTableColumns = [
  { label: 'N. do empenho', value: 'office_number' },
  { label: 'Tipo', value: 'kind' },
  { label: 'Status', value: 'status' },
  { label: 'Valor do empenho', value: 'total_value' },
  { label: 'Período de competência', value: 'applicable_date' },
  { label: 'Filial', value: 'company_branch' },
  { label: 'Data de upload', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-9' },
];
